const mutation = {
  BOOTSTRAP_LOADING(state, status) {
    state.isBootstrapLoading = status;
  },
  BOOTSTRAP_RELOADING(state, status) {
    state.isBootstrapReLoading = status;
  },
  MDM_BOOTSTRAP_DATA(state, data) {
    state.mdmBoostrap = data;
  },
  BOOTSTRAP_DATA(state, data) {
    state.data = data;
  },
  LOGGED_IN(state, status) {
    state.isLoggedIn = status;
  },
  CURRENT_CLIENT(state, data) {
    state.currentClient = data;
  },
  CURRENT_CLIENT_CONFIG(state, data) {
    state.currentClientConfig = data;
  },
  UPDATE_GST(state, data) {
    state.data.transporter.gst_number = data;
  },
  SET_LOGO(state, data) {
    state.data.transporter.logo_url = data.url;
  },
  setUploading(state, data) {
    state.isUploading = data;
  },
  ADD_SAC(state, data) {
    if (state.data.transporter.hsn_sac) { state.data.transporter.hsn_sac = data; }
  },
  SHOW_TERMS_DIALOG(state, status) {
    state.showTermsDialog = status;
  },
  ENVIRONMENT_DATA(state, data) {
    state.environmentVariables = data;
  },
  SET_FILTER_VISIBILITY(state, data) {
    state.hideFilter = data;
  },
  SET_IS_PAYMENT_ERROR(state, data) {
    state.isPaymentError = data;
  }
};

export default mutation;
